import { render, staticRenderFns } from "./PetGender.vue?vue&type=template&id=7f8415ee"
import script from "./PetGender.vue?vue&type=script&lang=js"
export * from "./PetGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports